<div class="product-count-info">

    <div (click)="onPreviousBtnClicked()" class="ps-back">
        <i class="fa fa-chevron-left"></i>
        Zurück
    </div>



    <div class="title">Geht es um potentiell mehr als 50 Brother-Produkte bei Ihrem Kundenprojekt?</div>

    <div class="radio-line"></div>
    <div class="radio-container"  bdFxLayoutAlign="start center">


        <div bdFxFlex="1 1 auto"  bdFxLayoutAlign="start center" (click)="setProductCountInfo(salesConciergeProductCount.LESS_THAN_50)"


        [ngClass]="{'bd-radio': true, 'selected': selectedProductCount === salesConciergeProductCount.LESS_THAN_50 || salesConciergeProductCount.LESS_THAN_50 === salesConciergeProductCount[salesConciergeRequest?.productCountInfo]}">

        </div>
        <div bdFxFlex="1 1 293px"   bdFxLayoutAlign="start center"></div>
        <div bdFxFlex="1 1 auto"    bdFxLayoutAlign="start center" (click)="setProductCountInfo(salesConciergeProductCount.NO_INFORMATION)" [ngClass]="{'bd-radio': true, 'selected': selectedProductCount === salesConciergeProductCount.NO_INFORMATION || salesConciergeProductCount.NO_INFORMATION === salesConciergeProductCount[salesConciergeRequest?.productCountInfo]}">

        </div>
        <div bdFxFlex="1 1 293px"   bdFxLayoutAlign="start center"></div>
        <div bdFxFlex="1 1 auto"  bdFxLayoutAlign="start center" (click)="setProductCountInfo(salesConciergeProductCount.MORE_THAN_50)" [ngClass]="{'bd-radio': true, 'selected': selectedProductCount === salesConciergeProductCount.MORE_THAN_50 || salesConciergeProductCount.MORE_THAN_50 === salesConciergeProductCount[salesConciergeRequest?.productCountInfo]}">

        </div>

    </div>
    <div class="radio-container-text"  bdFxLayoutAlign="start center">
        <div bdFxFlex bdFxLayoutAlign="start center" >
            {{salesConciergeProductCount.LESS_THAN_50}}
        </div>
        <div  bdFxFlex bdFxLayoutAlign="center center" >
            {{salesConciergeProductCount.NO_INFORMATION}}
        </div>
        <div bdFxFlex bdFxLayoutAlign="end center">
            {{salesConciergeProductCount.MORE_THAN_50}}
        </div>

    </div>


</div>
